// removed by extract-text-webpack-plugin
module.exports = {"hiddenIframe":"IframeUtil-hashed__hiddenIframe__HHiY1"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-js/utils/IframeUtil/IframeUtil-hashed.scss
// module id = 680
// module chunks = 0